module.exports = __webpack_public_path__ + "static/media/mockup-ums-1.7d4bf3ec.jpg";